/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientPrescriptions = sqliteTable('patient_prescriptions', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  patient_id: text('patient_id'),
  encounter_id: text('encounter_id'),
  visit_id: text('visit_id'),
  appointment_id: text('appointment_id'),
  queue_id: text('queue_id'),
  item_name: text('item_name'),
  item_details: text('item_details'),
  intake_timing: text('intake_timing'),
  dose_quantity: text('dose_quantity'),
  schedule_morning: integer('schedule_morning'),
  schedule_afternoon: integer('schedule_afternoon'),
  schedule_night: integer('schedule_night'),
  duration_value: integer('duration_value'),
  duration_unit: text('duration_unit'),
  instructions: text('instructions'),
  sort_order: integer('sort_order'),
  author_user_id: text('author_user_id'),
  author_name: text('author_name'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
